// extracted by extract-css-chunks-webpack-plugin
module.exports = {"price_sale":"css-WFR4ilIL4r","price__productItem":"css-1nK1rXCP-H","price_strikeThrough":"css-SoWzBH4xJB","price__product":"css-3xIF5KooV-"};